import React from "react";

const SwitchingBackgroundPattern = () => {
  return (
    <div
      className="absolute top-0 left-0 w-full h-full space-y-3 pt-[300px] z-0"
      id="switching-background-pattern"
    >
      <div className="w-full h-[13px] bg-[#3c41ae]"></div>
      <div className="w-full h-[11px] bg-[#5d36a7]"></div>
      <div className="w-full h-[9px] bg-[#822a9f]"></div>
      <div className="w-full h-[7px] bg-[#ff0085]"></div>
    </div>
  );
};

export default SwitchingBackgroundPattern;
